import { ref } from 'vue';
import type { ServiceUseCaseItem } from '@/models/service';

export const useUseCaseList = async () => {
  const { isLoading, handleLoading } = useLoading(true);

  const useCases = ref<ServiceUseCaseItem[]>();

  const loadUseCaseList = async () => {
    useCases.value = await handleLoading($api<ServiceUseCaseItem[]>('/use-case'));
  };

  await loadUseCaseList();

  return {
    isLoading,
    useCases
  };
};
